import { combineReducers, configureStore } from "@reduxjs/toolkit";
import commonReducer from "../store/slices/common.slice";
import vscDashboardReducer from "../modules/vscDashboard/store/dashboard.slice";
import contractDraftDashboardReducer from "../modules/ContractDraft/store/contractDraftDashboard.slice";
import { Auth } from "../auth/auth";
import tableInfoReducer from "./slices/table.slice";
import { ROUTES } from "../common/constants";
import userInfoReducer from "./slices/userInfo.slice";
import adminReducer from "../modules/Admin/store/admin.slice";
import antdTableReducer from "./slices/antdTable.slice";
import lazyLoadReducer from "./slices/lazyLoad.slice";
import contractDraftingDetailReducer from "../modules/ContractDraft/Pages/ContractDraftingDetail/store/contractDraftingDetail.slice";

export const ROOT_REDUCER_ACTIONS = {
  LOGOUT: "LOGOUT",
};

const combinedReducer = combineReducers({
  commonReducer: commonReducer,
  vscDashboardReducer: vscDashboardReducer,
  contractDraftDashboardReducer: contractDraftDashboardReducer,
  tableInfoReducer: tableInfoReducer,
  userInfoReducer: userInfoReducer,
  adminReducer: adminReducer,
  antdTableReducer: antdTableReducer,
  lazyLoadReducer: lazyLoadReducer,
  contractDraftingDetailReducer: contractDraftingDetailReducer,
});

const rootReducer = (state: any, action: any) => {
  switch (action.type) {
    case ROOT_REDUCER_ACTIONS.LOGOUT:
      const auth = Auth.getInstance();
      auth.discardSession();
      try {
        localStorage.removeItem('orbit_active_draft_jobs');
      } catch {}
      window.location.replace(ROUTES.login);
      state = {};
      break;
    default:
      break;
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: {
    rootReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
